import React from 'react';
import { RouterProvider } from 'react-router-dom';
import AuthProvider from 'react-auth-kit';
import router from './router';
import authStore from './authStore';
import { store } from './store/store';
import { Provider } from 'react-redux';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import InfoCard from './components/InfoCard';

const App: React.FC = () => {
  return (
    <AuthProvider store={authStore}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <>
            <InfoCard />

            <RouterProvider router={router} />
          </>
        </I18nextProvider>
      </Provider>
    </AuthProvider>
  );
};

export default App;
